import { createCacheLockInfo } from '../utils/createCacheLockInfo';
import { EventEntity } from '../schema/EventEntity';
import { EventsCache, EventsCacheLockId } from '../schema/EventsCache';

export function tryInitializeLockInfo<T extends EventEntity>(
    lockId: EventsCacheLockId,
    cache: EventsCache<T>
) {
    if (!cache.locksInfo.get(lockId)) {
        cache.locksInfo.set(lockId, createCacheLockInfo());
    }
}
